
// Plus (no customization + engraving popup) start js
(function($){
  $(function(){
    /* ensure preview container exists */
    if ($('.charms-preview-container').length === 0) {
      if ($('.charms-upsell').length) {
        $('.charms-upsell').after('<div class="charms-preview-container"></div>');
      } else {
        $('body').append('<div class="charms-preview-container"></div>');
      }
    }
    /* -------------------------
       NO CUSTOMIZATION
    ------------------------- */
    $(document).on('click', '.charms-upsell__plus.no_customization', function (e) {
      e.preventDefault();
      let $circle = $(this).closest('.charms-upsell__circle');
      let $item = $circle.closest('.charms-upsell__item');
      let $qtyControls = $circle.find('.charms-upsell__qty-controls');
      let $qtyVal = $circle.find('.qty-value');
      let productId = $item.data('id');
      let title = $item.find('.charms-upsell__title_preview').text().trim();
      let imgSrc = $circle.find('img').attr('src') || '';
      let price = $item.find('.charms-upsell__Price').text().trim();
      let compare_price = $item.find('.charms-upsell__compare_price').text().trim();
      let currentQty = parseInt($circle.attr('data-qty')) || 0;
      if ($qtyControls.is(':visible')) {
        currentQty++;
      } else {
        $qtyControls.show();
        currentQty = 1;
      }
      $circle.attr('data-qty', currentQty);
      $qtyVal.text(currentQty);
      let previewId = 'preview-' + productId + '-' + Date.now() + '-' + Math.floor(Math.random()*1000);
      $('.charms-preview-container').append(`
        <div class="charms-preview-item" 
             data-type="no-custom" 
             data-id="${productId}" 
             data-preview-id="${previewId}">
          <img src="${imgSrc}" alt="${title}">
          <div class="preview-actions">
            <button type="button" class="preview-close" data-preview-id="${previewId}">×</button>
          </div>
          <p class="preview-title">${title}</p>
         <div class="custom_price_preview">
          <p class="preview-price">${price}</p>
          <p class="compare_preview-price">${compare_price}</p>
          <div>
          
        </div>
      `);
    });
    $(document).on('click', '.qty-minus', function (e) {
      e.preventDefault();
      let $circle = $(this).closest('.charms-upsell__circle');
      let $item = $circle.closest('.charms-upsell__item');
      let productId = $item.data('id');
      let $qtyVal = $circle.find('.qty-value');
      let currentQty = parseInt($circle.attr('data-qty')) || 0;
      if (currentQty > 1) {
        currentQty--;
        $circle.attr('data-qty', currentQty);
        $qtyVal.text(currentQty);
        $(`.charms-preview-container .charms-preview-item[data-type="no-custom"][data-id="${productId}"]:last`).remove();
      } else {
        $circle.find('.charms-upsell__qty-controls').hide();
        $circle.attr('data-qty', 0);
        $qtyVal.text(1);
        $(`.charms-preview-container .charms-preview-item[data-type="no-custom"][data-id="${productId}"]`).remove();
      }
    });
    /* -------------------------
       ENGRAVING (single product)
    ------------------------- */
    let engravingTarget = null;
    $(document).on('click', '.charms-upsell__plus.engraving_text', function (e) {
      e.preventDefault();
      engravingTarget = $(this).closest('.charms-upsell__circle');
      $('#engraving-input').val('');
      $('#engraving-error').hide();
      $('#engraving-popup').show();
    });
    $(document).on('click', '#engraving-cancel', function (e) {
      e.preventDefault();
      $('#engraving-popup').hide();
      engravingTarget = null;
    });
    $(document).on('click', '#engraving-submit', function (e) {
      e.preventDefault();
      if (!engravingTarget) return;
      let engravingText = $('#engraving-input').val().trim();
      if (engravingText === '') {
        $('#engraving-error').show();
        return;
      }
      $('#engraving-error').hide();
      let $circle = engravingTarget;
      let $item = $circle.closest('.charms-upsell__item');
      let $qtyControls = $circle.find('.engraving-qty-controls');
      let $qtyVal = $qtyControls.find('.engraving-qty-value');
      let productId = $item.data('id');
      let title = $item.find('.charms-upsell__title_preview').text().trim();
      let imgSrc = $circle.find('img').attr('src') || '';

      let price = $item.find('.charms-upsell__Price').text().trim();
      let compare_price = $item.find('.charms-upsell__compare_price').text().trim();

      let currentQty = parseInt($circle.attr('data-qty')) || 0;
      if (!$qtyControls.is(':visible')) {
        $qtyControls.show();
        currentQty = 0;
      }
      currentQty++;
      $circle.attr('data-qty', currentQty);
      $qtyVal.text(currentQty);
      let previewId = 'preview-' + productId + '-' + Date.now() + '-' + Math.floor(Math.random()*1000);
      $('.charms-preview-container').append(`
        <div class="charms-preview-item engraving-preview" 
             data-type="engraving" 
             data-id="${productId}" 
             engraving-text="${engravingText}"
             data-preview-id="${previewId}">
          <img src="${imgSrc}" alt="${title}">
          <div class="preview-actions">
            <button type="button" class="preview-close" data-preview-id="${previewId}">×</button>
          </div>
          <p class="preview-title">${title}</p>
          <p class="engraving-text"><strong>Engraving:</strong> ${engravingText}</p>
          <div class="custom_price_preview">
          <p class="preview-price">${price}</p>
          <p class="compare_preview-price">${compare_price}</p>
          <div>
          
        </div>
      `);
    $('#engraving-popup').hide();
      engravingTarget = null;
    });
    
    // Multi-product engraving minus
    $(document).on('click', '.engraving-minus', function (e) {
      
      e.preventDefault();
      let $circle = $(this).closest('.charms-upsell__circle');
      let $item = $circle.closest('.charms-upsell__product, .charms-upsell__item');
      let productId = $item.data('id');
      
      let $qtyVal = $circle.find('.engraving-qty-value');
      let $qtyControls = $circle.find('.engraving-qty-controls');
      let currentQty = parseInt($circle.attr('data-qty')) || 0;
 
      if (currentQty > 1) {
        currentQty--;
        $circle.attr('data-qty', currentQty);
        $qtyVal.text(currentQty);
        // Remove last preview from **external** container
        $(`.charms-preview-container .charms-preview-item[data-type="engraving"][data-id="${productId}"]:last`).remove();
        // Remove last preview from **internal popup** container (if exists)
        $circle.closest('.engraving-popup').find(`.engraving-preview-container .charms-preview-item[data-type="engraving"][data-id="${productId}"]:last`).remove();
      } else {
        $qtyControls.hide();
        $circle.attr('data-qty', 0);
        $qtyVal.text(1);
        // Remove all previews for this product
        $(`.charms-preview-container .charms-preview-item[data-type="engraving"][data-id="${productId}"]`).remove();
        $circle.closest('.engraving-popup').find(`.engraving-preview-container .charms-preview-item[data-type="engraving"][data-id="${productId}"]`).remove();
      }
    });
    /* -------------------------
       ENGRAVING MULTI-PRODUCT (popup)
    ------------------------- */

    let multiEngravingTarget = null;
    // Open multi-product engraving popup
    $(document).on('click', '.charms-upsell__plus.engraving_text_popup', function(e){
      e.preventDefault();
          $(this).closest(".charms-upsell__item").find(".multiple_product_engraving_popup").fadeIn();
    });
 
    // Close main engraving popup
    $(document).on('click', '.engraving-popup .charms-upsell__close', function(e){
      e.preventDefault();
      $(this).closest('.engraving-popup').fadeOut();
    });

$(document).on('click', function(e) {
  var $target = $(e.target);

  if (
    $target.closest('.no_charms-upsell__popups').length ||
    $target.closest('.custom_charms-upsell__plus.custom_yes_customization').length ||
    $target.closest('.custom_charms-upsell__plus.engraving_text_popup').length ||
    $target.closest('.charms_upsell__plus_image.image_select_plus').length ||
    $target.closest('.preview-close').length ||
    $target.closest('.multiple_product_engraving_popup .charms-upsell__popup-inner').length || 
    $target.closest('.inner-layer').length ||  
    $target.closest('.inner-layer-left').length ||  
    $target.closest('.inner-layer-right').length ||
    $target.closest('.charms-upsell__popup.image-upload-popup').length
  ) {
    return; 
  }
  $(".no_customization_popup .charms-upsell__popups")
    .find(".charms-upsell__close")
    .trigger("click");

  $(".engraving-popup.multiple_product_engraving_popup")
    .find(".charms-upsell__close")
    .trigger("click");

    $(".engraving-popup.multiple_product_engraving_popup")
    .find(".engraving-text-cancel")
    .trigger("click");

});



    // Open product-specific engraving text popup inside multi-product popup
    $(document).on('click', '.engraving-text-trigger', function(e){
      e.preventDefault();
      multiEngravingTarget = $(this).closest('.charms-upsell__circle');
      let $textPopup = $(this).closest('.engraving-popup').find('.engraving-text-popup-container');
      $textPopup.show();
      $(".multiple_product_engraving_popup").addClass("custom_engraving_popup");
      $textPopup.find('.engraving-input').val('');
      $textPopup.find('.engraving-error').hide();
    });
    // Cancel engraving text popup
    $(document).on('click', '.engraving-text-cancel', function(e){
      e.preventDefault();
      $(this).closest('.engraving-text-popup-container').hide();
      $(".multiple_product_engraving_popup").removeClass("custom_engraving_popup");
      multiEngravingTarget = null;
    });

    // Hide engraving error when user starts typing
    $(document).on('input', '.engraving-input, #engraving-input', function() {
      $(this).siblings('.engraving-error, #engraving-error').hide();
    });


    // Submit engraving text for multi-product popup
    $(document).on('click', '.engraving-submit', function(e){
      e.preventDefault();
      if(!multiEngravingTarget) return;
      let engravingText = $(this).siblings('.engraving-input').val().trim();
      if(engravingText === ''){
        $(this).siblings('.engraving-error').show();
        return;
      }
      $(this).siblings('.engraving-error').hide();
      let $circle = multiEngravingTarget;
      let $item = $circle.closest('.charms-upsell__product');
      let $qtyControls = $circle.find('.engraving-qty-controls');
      let $qtyVal = $qtyControls.find('.engraving-qty-value');
      let productId = $item.data('id');
      let title = $item.find('.charms-upsell__title').text().trim();
      let price = $item.find('.charms-upsell__Price').text().trim();
      let compare_price = $item.find('.charms-upsell__compare_price').text().trim();
      let imgSrc = $circle.find('img').attr('src') || '';
      let currentQty = parseInt($circle.attr('data-qty')) || 0;
      if(!$qtyControls.is(':visible')){
        $qtyControls.show();
        currentQty = 0;
      }
 
      currentQty++;
      $circle.attr('data-qty', currentQty);
      $qtyVal.text(currentQty);
      let previewId = 'preview-' + productId + '-' + Date.now() + '-' + Math.floor(Math.random()*1000);
      // External preview
      $('.charms-preview-container').append(`
        <div class="charms-preview-item engraving-preview" 
             data-type="engraving" 
             data-id="${productId}" 
             engraving-text="${engravingText}"
             data-preview-id="${previewId}">
          <img src="${imgSrc}" alt="${title}">
           <div class="preview-actions">
            <button type="button" class="preview-close" data-preview-id="${previewId}">×</button>
          </div>
          <p class="preview-title">${title}</p>
          <p class="engraving-text"><strong>Engraving:</strong> ${engravingText}</p>
         <div class="custom_price_preview">
          <p class="preview-price">${price}</p>
          <p class="compare_preview-price">${compare_price}</p>
          <div>
         
        </div>
      `);
      // Internal preview inside popup
      let $internalPreview = $circle.closest('.engraving-popup').find('.engraving-preview-container');
      $internalPreview.append(`
        <div class="charms-preview-item engraving-preview" 
             data-type="engraving" 
             data-id="${productId}" 
             engraving-text="${engravingText}"
             data-preview-id="${previewId}">
          <img src="${imgSrc}" alt="${title}">
           <div class="preview-actions">
            <button type="button" class="preview-close" data-preview-id="${previewId}">×</button>
          </div>
          <p class="preview-title">${title}</p>
          <p class="engraving-text"><strong>Engraving:</strong> ${engravingText}</p>
          <div class="custom_price_preview">
          <p class="preview-price">${price}</p>
          <p class="compare_preview-price">${compare_price}</p>
          <div>
         
        </div>
      `);
      $(this).closest('.engraving-text-popup-container').hide();
      multiEngravingTarget = null;
        $(".multiple_product_engraving_popup").removeClass("custom_engraving_popup");
    });
    /* -------------------------
       PREVIEW CLOSE (shared)
    ------------------------- */
    $(document).on('click', '.charms-preview-item .preview-close', function (e) {
      e.preventDefault();
      let previewId = $(this).data('preview-id');
      let $preview = $(`.charms-preview-item[data-preview-id="${previewId}"]`);
      if (!$preview.length) return;
      let productId = $preview.data('id');
      let type = $preview.data('type'); // "no-custom" or "engraving"
      $preview.remove();
      let remaining = $(`.charms-preview-container .charms-preview-item[data-type="${type}"][data-id="${productId}"]`).length;
      let $circle = $(`.charms-upsell__item[data-id="${productId}"] .charms-upsell__circle,
                        .charms-upsell__product[data-id="${productId}"] .charms-upsell__circle`);
      if (type === 'engraving') {
        let $qtyVal = $circle.find('.engraving-qty-value');
        let $qtyControls = $circle.find('.engraving-qty-controls');
        if (remaining > 0) {
          $qtyVal.text(remaining);
          $circle.attr('data-qty', remaining);
        } else {
          $qtyControls.hide();
          $qtyVal.text(1);
          $circle.attr('data-qty', 0);
        }
      } else { // no-custom
        let $qtyVal = $circle.find('.qty-value');
        let $qtyControls = $circle.find('.charms-upsell__qty-controls');
        if (remaining > 0) {
          $qtyVal.text(remaining);
          $circle.attr('data-qty', remaining);
        } else {
          $qtyControls.hide();
          $qtyVal.text(1);
          $circle.attr('data-qty', 0);
        }
      }
    });
  });
})(jQuery);




// Keep reference of the original engraving popup
let engravingPopup = null;

$(document).ready(function() {
  engravingPopup = $('#engraving-popup');

  // Observe DOM changes (e.g., when color swatches reload)
  const observer = new MutationObserver(() => {
    // If popup got removed accidentally, reattach it at the end of <body>
    if ($('#engraving-popup').length === 0 && engravingPopup) {
      $('body').append(engravingPopup);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// Plus (no customization + engraving popup) end js



// Plus popup start js

(function ($) {
  $(function () {

   $(document).on('click', '.custom_charms-upsell__plus.yes_customization', function(e){
      e.preventDefault();
      let parentId = $(this).data('id');
      $('.charms-upsell__popups-' + parentId).fadeIn();
    });

    // Ensure global external preview container exists
    if ($('.charms-preview-container').length === 0) {
      $('body').append('<div class="charms-preview-container"></div>');
    }

    // Helper → update qty only from popup previews
    function updateQtyFromPopup($popup, productId) {
      let $circle = $popup.find(`.charms-upsell__product[data-id="${productId}"] .charms-upsell__circle`);
      let $qtyVal = $circle.find('.qty-value');
      let $qtyControls = $circle.find('.charms-upsell__qty-controls');

      // Count only inside THIS popup
      let remaining = $popup.find(`.charms-popup-preview .charms-preview-item[data-id="${productId}"]`).length;

      if (remaining > 0) {
        $qtyVal.text(remaining);
        $circle.attr('data-qty', remaining);
        $qtyControls.show();
      } else {
        $qtyVal.text(1);
        $circle.attr('data-qty', 0);
        $qtyControls.hide();
      }
    }

    $(document).on('click', '.custom_charms-upsell__plus.custom_yes_customization', function (e) {
        e.preventDefault();
        $('.custom-charms-popup .charms-upsell__popups').hide();
        const $popup = $(this).closest('.custom_no_cusotmization').find('.custom-charms-popup .charms-upsell__popups');
        $popup.show();
    });

    // Close button
    $(document).on('click', '.charms-upsell__close', function (e) {
       e.preventDefault();
      $(this).closest('.charms-upsell__popups').hide();
    });


    $(document).on('click', '.custom_charms-upsell__plus.popup-plus', function (e) {
  e.preventDefault();

  let $circle = $(this).closest('.charms-upsell__circle');
  let $product = $(this).closest('.charms-upsell__product');
  let $popup = $(this).closest('.custom-charms-popup');
  let $internalPreview = $popup.find('.charms-popup-preview');
  let $externalPreview = $('.charms-preview-container');

  let productId = $product.data('id');
  let title = $product.find('.charms-upsell__title').text().trim();
   let price = $product.find('.charms-upsell__Price').text().trim();
  let compare_price = $product.find('.charms-upsell__compare_price').text().trim();
  let imgEl = $circle.find('img');
  let imgSrc = imgEl.attr('src') || '';
 
  let uniqueId = 'preview-' + productId + '-' + Date.now();

  // Add preview inside popup
  $internalPreview.append(`
    <div class="charms-preview-item yes-custom-preview" 
         data-id="${productId}" 
         data-unique="${uniqueId}" 
         >
      <img src="${imgSrc}" alt="${title}">
      <div class="preview-actions">
        <button type="button" class="preview-close" data-unique="${uniqueId}">×</button>
      </div>
      <p class="preview-title">${title}</p>
      <div class="custom_price_preview">
          <p class="preview-price">${price}</p>
          <p class="compare_preview-price">${compare_price}</p>
          <div>
      
    </div>
  `);

  // Add preview outside (global)
  $externalPreview.append(`
    <div class="charms-preview-item yes-custom-preview" 
         data-id="${productId}" 
         data-unique="${uniqueId}" 
         >
      <img src="${imgSrc}" alt="${title}">
      <div class="preview-actions">
        <button type="button" class="preview-close" data-unique="${uniqueId}">×</button>
      </div>
      <p class="preview-title">${title}</p>
       <div class="custom_price_preview">
          <p class="preview-price">${price}</p>
          <p class="compare_preview-price">${compare_price}</p>
          <div>
      
    </div>
  `);

  // Update qty only from popup previews
  updateQtyFromPopup($popup, productId);
});




    // MINUS button → remove ONE product preview
    $(document).on('click', '.qty-minus', function (e) {
      e.preventDefault();
      let $circle = $(this).closest('.charms-upsell__circle');
      let $product = $(this).closest('.charms-upsell__product');
      let $popup = $(this).closest('.custom-charms-popup');
      let productId = $product.data('id');

      // Find last preview inside popup for this product
      let $lastInternal = $popup.find(`.charms-popup-preview .charms-preview-item[data-id="${productId}"]:last`);
      if ($lastInternal.length) {
        let uniqueId = $lastInternal.data('unique');
        $(`[data-unique="${uniqueId}"]`).remove(); // remove from both popup + global
      }

      // Update qty only from popup previews
      updateQtyFromPopup($popup, productId);
    });

    // Close (×) button on preview
    $(document).on('click', '.charms-preview-item .preview-close', function (e) {
      e.preventDefault();
      let uniqueId = $(this).data('unique');
      let $preview = $(`[data-unique="${uniqueId}"]`);
      let productId = $preview.data('id');
      let $popup = $preview.closest('.custom-charms-popup');

      // Remove same preview from both popup + global
      $(`[data-unique="${uniqueId}"]`).remove();

      // Update qty only from popup previews
      updateQtyFromPopup($popup, productId);
    });
 
  });
})(jQuery);




// image uplaod start js

$(document).on("click", ".image_popup_plus", function () {
  $(".custom_select_image-popup").css("display", "block");
});

// Close popup
$(document).on("click", ".custom_select_image-popup .charms-upsell__close", function () {
  $(".custom_select_image-popup").css("display", "none");
});


$(document).on("click", ".image-upload-trigger", function () {
  let productId = $(this).data("product");

  // Hide all popups first
  $(".image-upload-popup-container").hide();

  // Find the correct popup for this trigger
  const popup = $(this)
    .closest(".charms-upsell__popup")
    .find(".image-upload-popup-container");

  // Fade in and trigger file click immediately
  popup.fadeIn(200);
  popup.find(".custom_upload-file").trigger("click");

  // Mark the clicked product as active
  $(this)
    .closest(".charms-upsell__products")
    .find(".image-product")
    .removeClass("active");
  $(this).closest(".image-product").addClass("active");
});


// Close upload popup
$(document).on("click", ".image-upload-cancel", function(){
  $(this).closest(".image-upload-popup-container").fadeOut();
});

$(document).on("click", ".custom_select_image-popup  .charms-upsell__close", function() {
  // Close all upload popups
  $(".image-upload-popup-container").fadeOut();
  const parentPopup = $(this).closest(".custom_select_image-popup");
  parentPopup.find(".image-product").removeClass("active");
  parentPopup.fadeOut();
});



// image color js

$(document).ready(function() {

  function selectPopupColor($colorItem, $popup) {
    var selectedColor = $colorItem.data('color');
    var $allColors = $popup.find('.color-item');
    var $products = $popup.find('.charms-upsell__product');

    // Remove active state from all colors
    $allColors.removeClass('selected active-color');

    // Reset previous state (only in this popup)
    $allColors.removeClass('already-selected');
    $popup.find('.no-products-message').remove();
    $popup.find('.engraving-products').removeClass('custom_parent_engraving_');
    $popup.find('.charms-upsell__products').removeClass('custom_parent_birthstone custom_parent_image');

    // Mark this one as selected
    $colorItem.addClass('selected active-color already-selected');

    // Update the inside-selected-color span
    $popup.find('.inside-selected-color').attr('data-placeholder', selectedColor).text(selectedColor);

    // Track if any product matches
    var matchFound = false;

    // Filter products by color
    $products.each(function() {
      var productColor = $(this).data('color');
      if (productColor === selectedColor) {
        $(this).show();
        matchFound = true;
      } else {
        $(this).hide();
      }
    });

    // If no product matches → show message inside this popup only
    if (!matchFound) {
      if ($popup.hasClass('multiple_product_engraving_popup')) {
        $popup.find('.engraving-products').addClass('custom_parent_engraving_');
      }
      if ($popup.hasClass('no_customization_popup')) {
        $popup.find('.charms-upsell__products').addClass('custom_parent_birthstone');
      }
      if ($popup.hasClass('custom_select_image-popup')) {
        $popup.find('.charms-upsell__products').addClass('custom_parent_image');
      }

      $products.parent().append('<div class="no-products-message" style="margin-top:10px; color:red; font-size:14px;">No products found for this color</div>');
      
      $popup.find('.popup_product_heading_').hide();
    } else {
        $popup.find('.popup_product_heading_').show();
    }
  }

  // Click handler
  $(document).on('click', '.custom_select_image-popup .color-item, .no_customization_popup .color-item, .multiple_product_engraving_popup .color-item', function() {
    var $popup = $(this).closest('.custom_select_image-popup, .no_customization_popup, .multiple_product_engraving_popup');
    selectPopupColor($(this), $popup);
  });

  // Automatically select first color in each popup on page load
  $('.custom_select_image-popup, .no_customization_popup, .multiple_product_engraving_popup').each(function() {
    var $popup = $(this);
    var $firstColor = $popup.find('.color-item').first();
    if ($firstColor.length) {
      selectPopupColor($firstColor, $popup);
    }
  });

});


// outside color swatches
$(document).ready(function() {

  function selectColorItem(colorItem) {
    var selectedColor = $(colorItem).data('color');
    console.log("selectedColor", selectedColor);

    // Remove active state from all colors, then add to clicked
    $('.outside_color_swatches .color-item').removeClass('active-color');
    $(colorItem).addClass('active-color');

    // Update placeholder
    $('.selected-color').attr('data-placeholder', selectedColor);

    // Loop through all charm items
    $('.outside_charms-upsell.charms-upsell__item').each(function() {
      var itemColor = $(this).data('color');
      var multiType = $(this).data('multi');

      // Show only matching color items where data-multi="No"
      if (multiType === 'No') {
        if (itemColor === selectedColor) {
          $(this).show();
        } else {
          $(this).hide();
        }
      } else {
        $(this).show();
      }
    });
  }

  // Click handler
  $(document).on('click', '.outside_color_swatches .color-item', function() {
    selectColorItem(this);
  });

  // Automatically select the first color item on page load
  var firstColorItem = $('.outside_color_swatches .color-item').first();
  if (firstColorItem.length) {
    selectColorItem(firstColorItem);
  }

});




$(".inside_engraving_preview_done").click(function() {
  $(this).closest(".multiple_product_engraving_popup").find(".charms-upsell__close").trigger("click");
});

$(".inside_bithstone_preview_done").click(function() {
  $(this).closest(".no_charms-upsell__popups").find(".charms-upsell__close").trigger("click");
});

$(".inside_image_preview_done").click(function() {
  $(this).closest(".parent_custom_select_image-popup").find(".charms-upsell__close").trigger("click");
});



// // Handle click on left side (now acts like plus)
// $(document).on('click', '.single_popup_outside .inner-layer-left', function() {
//   const $circle = $(this).closest('.charms-upsell__circle');

//   // Trigger only the plus button
//   const $plusBtn = $circle.find('.outside_charms-upsell__plus').first();
//   if ($plusBtn.length) {
//     $plusBtn.trigger('click');
//   }
// });

// // Handle click on right side (still acts like plus)
// $(document).on('click', '.single_popup_outside .inner-layer-right', function() {
//   const $circle = $(this).closest('.charms-upsell__circle');

//   const $plusBtn = $circle.find('.outside_charms-upsell__plus').first();
//   if ($plusBtn.length) {
//     $plusBtn.trigger('click');
//   }
// });

$(document).on('click', '.single_popup_outside .inner-layer-left, .single_popup_outside .inner-layer-right', function(e) {
  e.preventDefault();
  e.stopPropagation();

  const $circle = $(this).closest('.charms-upsell__circle');

  // Check repeatedly until plus button appears
  const tryClickPlus = () => {
    const $plusBtn = $circle.find('.outside_charms-upsell__plus').eq(0);
    if ($plusBtn.length) {
      $plusBtn.trigger('click');
    } else {
      // Retry after a short delay (useful if DOM updates dynamically)
      setTimeout(tryClickPlus, 100);
    }
  };

  tryClickPlus();
});


// For “enable_popup_category” (dual click — minus + plus)
$(document).on('click', '.enable_popup_category .inner-layer', function() {
  const $circle = $(this).closest('.charms-upsell__circle');
  const $minusBtn = $circle.find('.custom_no_cusotmization .charms-upsell__qty-controls:visible .qty-minus').first();
  const $plusBtn = $circle.find('.outside_charms-upsell__plus').first();

  if ($minusBtn.length) $minusBtn.trigger('click');
  if ($plusBtn.length) $plusBtn.trigger('click');
});


$(document).on('click', '.enable_popup_category .image-product .image_inner-layer-left', function() {
  const $product = $(this).closest('.image-product'); // get the current product only

  $product.find('.custom_charms-upsell__plus.image-upload-trigger').first().trigger('click');
});

// Handle plus click on right side (trigger only for clicked product)
$(document).on('click', '.enable_popup_category .image-product .image_inner-layer-right', function() {
  const $product = $(this).closest('.image-product'); // get the current product only

  $product.find('.custom_charms-upsell__plus.image-upload-trigger').first().trigger('click');
});


$(document).on('click', '.enable_popup_category .no_customization_popup .no_customization_inner-layer-left', function() {
  const $product = $(this).closest('.charms-upsell__circle'); // get the current product only
  $product.find('.custom_charms-upsell__plus.popup-plus').first().trigger('click');
});

// Handle plus click on right side (trigger only for clicked product)
$(document).on('click', '.enable_popup_category .no_charms-upsell__popups .no_customization_inner-layer-right', function() {
  const $product = $(this).closest('.charms-upsell__circle'); // get the current product only
  $product.find('.custom_charms-upsell__plus.popup-plus').first().trigger('click');
});

$(document).on('click', '.enable_popup_category .multiple_product_engraving_popup .engraving_inner-layer-left', function() {
  const $product = $(this).closest('.charms-upsell__circle'); // get the current product only
  $product.find('.custom_charms-upsell__plus.engraving-text-trigger').first().trigger('click');
});

// Handle plus click on right side (trigger only for clicked product)
$(document).on('click', '.enable_popup_category .multiple_product_engraving_popup .engraving_inner-layer-right', function() {
  const $product = $(this).closest('.charms-upsell__circle'); // get the current product only
  $product.find('.custom_charms-upsell__plus.engraving-text-trigger').first().trigger('click');
});


// css
(function () {
  // helper: check one popup and toggle its done buttons
  function checkPopup($popup) {
    // 1) Charms (no_customization) preview
    const $noCustPreview = $popup.find('.no_customization_insidepreview');
    if ($noCustPreview.length) {
      const hasCharmsPreview = $noCustPreview.find('.charms-preview-item.yes-custom-preview').length > 0;
      $noCustPreview.css('border-top', hasCharmsPreview ? '1px solid #d1c9c9' : 'none');
      $popup.find('.inside_bithstone_preview_done').css('display', hasCharmsPreview ? 'block' : 'none');
    }

    // 2) Engraving preview
    const $engravingPreview = $popup.find('.engraving-preview-container');
    if ($engravingPreview.length) {
      const hasEngraving = $engravingPreview.find('.engraving-preview').length > 0;
      $engravingPreview.css('border-top', hasEngraving ? '1px solid #d1c9c9' : 'none');
      $popup.find('.inside_engraving_preview_done').css('display', hasEngraving ? 'block' : 'none');
    }

    // 3) Image upload preview
    const $uploadPreview = $popup.find('.custom_upload_container');
    if ($uploadPreview.length) {
      const hasUpload = $uploadPreview.find('.upload__preview-item').length > 0;
      $uploadPreview.css('border-top', hasUpload ? '1px solid #d1c9c9' : 'none');
      $popup.find('.inside_image_preview_done').css('display', hasUpload ? 'block' : 'none');
    }
  }

  // run once for all existing popups
  function runInitialCheck() {
    $('.charms-upsell__popup-inner, .parent_custom_select_image-popup').each(function () {
      checkPopup($(this));
    });

    // also try to find popups that may use a different wrapper
    $('.parent_custom_select_image-popup').each(function () {
      checkPopup($(this));
    });
  }

  // call initial check on DOM ready
  $(document).ready(function () {
    runInitialCheck();
  });

  // Observe the document for added/removed nodes and attribute changes inside popups
  const observer = new MutationObserver((mutations) => {
    // for performance, collect a set of popups that need checking
    const popupsToCheck = new Set();

    mutations.forEach((m) => {
      // If a node was added or removed, find its closest popup parent (if any)
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          const $node = $(node);
          const $popup = $node.closest('.charms-upsell__popup-inner, .parent_custom_select_image-popup');
          if ($popup.length) popupsToCheck.add($popup.get(0));
        });
      }
      if (m.removedNodes && m.removedNodes.length) {
        m.removedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          const $node = $(node);
          const $popup = $node.closest('.charms-upsell__popup-inner, .parent_custom_select_image-popup');
          if ($popup.length) popupsToCheck.add($popup.get(0));
        });
      }

      // If attributes changed on elements inside popups (like style changes), mark parent popup
      if (m.type === 'attributes' && m.target instanceof HTMLElement) {
        const $popup = $(m.target).closest('.charms-upsell__popup-inner, .parent_custom_select_image-popup');
        if ($popup.length) popupsToCheck.add($popup.get(0));
      }
    });

    // run checks for collected popups (or all if none collected)
    if (popupsToCheck.size) {
      popupsToCheck.forEach((el) => checkPopup($(el)));
    } else {
      // fallback: check all popups (cheap if changes are rare)
      $('.charms-upsell__popup-inner, .parent_custom_select_image-popup').each(function () {
        checkPopup($(this));
      });
    }
  });

  // observe the whole document subtree (we only react to changes inside popups)
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'data-id'] // optimize a bit
  });
})();





// popup css
const custom = document.querySelector('.shopify-section-group-header-group.section-header');

function checkPopup() {
  const withinTopRange = window.scrollY <= 100; // 0–100px range
  let popupVisible = false;

  document.querySelectorAll('.charms-upsell__popups').forEach(popup => {
    if (getComputedStyle(popup).display === 'block') {
      popupVisible = true;
    }
  });

  // z-index तभी लगे जब popup दिख रहा हो + top range में हों
  custom.style.zIndex = (popupVisible && withinTopRange) ? '2' : '';
}

// observe popup visibility
const observer = new MutationObserver(checkPopup);
observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['style', 'class']
});

// on load + on scroll (UP या DOWN दोनों में काम करेगा)
window.addEventListener('load', checkPopup);
window.addEventListener('scroll', checkPopup);

